// extracted by mini-css-extract-plugin
export default {"countdown":"saa-z","srOnly":"taa-z"};